module.exports = __webpack_public_path__ + "img/62b7419.jpg";